import { setEqualHeightWithCondition } from './equalHeight.js';
setEqualHeightWithCondition( '.e-stn--counter-with-gradients', '.e-ctr__d', () => window.innerWidth > 768, 200 );